// @flow
import { ErrorMessage } from "views/components/Message";
import {
	FacebookOutlined,
	GoogleOutlined,
	WindowsOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import { LoginButton } from "views/components/LoginButton";
import { LoginWithUsername } from "views/components/LoginWithUsername";
import { Spacer } from "views/components/common/Spacer";
import React from "reactn";
import WelcomeProvider from "views/components/Welcome";
import bg from "./welcome-bg.png";
import styled from "styled-components";
import { Alert } from "antd";

const Welcome = ({
	referrer,
	version,
	logIn,
	loadingGoogle,
	loadingFacebook,
	loadingMicrosoft,
	error,
	showLabel,
}) => {
	// if (loading) return <Spinner full />;
	return (
		<Onboarding>
			<div>
				<h3>
					Inicia Sesión en <span>ZeroQ</span>
				</h3>
				<LoginWithUsername referrer={referrer} />
				<Spacer rows={1} />
				{/* <ErrorMessage error={error} /> */}

				{showLabel && (
					<Alert
						description={
							"Si no pudiste ingresar, actualiza la página e inténtalo de nuevo"
						}
						type={"success"}
					/>
				)}
				<Spacer rows={1} />

				<p> O también puedes ingresar con: </p>
				<LoginButton
					label="Continuar con Google"
					onClick={logIn("google")}
					icon={GoogleOutlined}
					loading={loadingGoogle}
					size={"full"}
				/>
				<Spacing />
				{/* <LoginButton
					label="Continuar con Facebook"
					onClick={logIn("facebook")}
					icon={FacebookOutlined}
					loading={loadingFacebook}
					size={"full"}
				/>
				<Spacing /> */}
				<LoginButton
					label="Continuar con Microsoft"
					onClick={logIn("microsoft")}
					icon={WindowsOutlined}
					loading={loadingMicrosoft}
					size={"full"}
				/>

				<Spacing />
				{version}
			</div>
			<div>
				<h2>¿Primera vez en ZeroQ?</h2>
				<p>No pierdas más tiempo y regístrate.</p>
				<Link to="/signup">
					<LoginButton label="Registrarme" />
				</Link>
			</div>
		</Onboarding>
	);
};

export const Onboarding = ({ children }) => {
	const ch = React.Children.toArray(children);
	return (
		<Wrapper>
			<Container>
				<LeftPanel>
					<LeftPanelContent>{ch[0]}</LeftPanelContent>
				</LeftPanel>
				<RightPanel>
					<RegisterContent>{ch[1]}</RegisterContent>
				</RightPanel>
			</Container>
		</Wrapper>
	);
};

export default WelcomeProvider(Welcome);

const Spacing = styled.div`
	width: 100%;
	height: 8px;
`;

const Wrapper = styled.div`
	height: 1000px;
	padding-top: 80px;
`;

const Logo = styled.div`
	max-width: 865px;
	margin: 0 auto;
	& img {
		margin: 80px 0 40px 0;
		width: 180px;
	}
`;

const Container = styled.div`
	background-color: #fff;
	max-width: 1200px;
	min-height: 600px;
	margin: 0 auto;
	border-radius: 30px;
	display: flex;
	flex-direction: row;
`;

const LeftPanel = styled.div`
	padding-top: 55px;
	padding-bottom: 55px;
	width: 57%;
	height: 100%;
`;

const LeftPanelContent = styled.div`
	height: 100%;
	max-width: 380px;
	margin: 0 auto;
`;

const RightPanel = styled.div`
	width: 43%;
	background-image: url(${() => bg});
	background-size: cover;
	border-top-right-radius: 30px;
	border-bottom-right-radius: 30px;
	display: flex;
	align-items: center;

	@media screen and (min-width: 900px) {
		& {
		}
	}
`;

const RegisterContent = styled.div`
	color: #fff;
	text-align: center;
	width: 100%;
	max-width: 286px;
	margin: 0 auto;

	& h2 {
		color: #fff !important;
		font-weight: 600;
	}
`;
